import { render } from "./CrudList.vue?vue&type=template&id=48b6f9a2&scoped=true"
import script from "./CrudList.vue?vue&type=script&lang=js"
export * from "./CrudList.vue?vue&type=script&lang=js"

import "./CrudList.vue?vue&type=style&index=0&id=48b6f9a2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48b6f9a2"]])

export default __exports__